"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h5", null, "Contacts"));
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organiser Name");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "National Association Membership Number");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organiser Email");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "If person responsible for entries is not the organiser:");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Entries To:");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Email:");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Published Email:");
var _ref9 = /*#__PURE__*/_react.default.createElement("p", {
  className: "small"
}, "Note: If you are using www.canoeslalomentries.co.uk for entries then access will be provided to the individual emails for the organiser and the person taking entries. Only the published email will be shown online or in the year book.");
class Contacts extends _react.Component {
  render() {
    const application = this.props.application;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "organiserName",
      value: application.organiserName,
      onChange: this.props.setValue,
      maxLength: 100
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "organiserNAnumber",
      value: application.organiserNAnumber,
      onChange: this.props.setValue,
      maxLength: 100
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "organiserEmail",
      value: application.organiserEmail,
      onChange: this.props.setValue,
      maxLength: 100
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, _ref5, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "entriesTo",
      value: application.entriesTo,
      onChange: this.props.setValue,
      maxLength: 100
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "entriesEmail",
      value: application.entriesEmail,
      onChange: this.props.setValue,
      maxLength: 100
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "publishedEmail",
      value: application.publishedEmail,
      onChange: this.props.setValue,
      maxLength: 100
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, _ref9));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Contacts, "partialQueries", {
  Application: {
    id: true,
    organiserName: true,
    organiserNAnumber: true,
    organiserEmail: true,
    entriesTo: true,
    entriesEmail: true,
    publishedEmail: true
  }
});
var _default = exports.default = Contacts;